import { useMemo } from 'react'

import { navItemsFor, type NavItem } from '@/app/navigation'
import { useCurrentUser } from '@/modules/accounts'

/** Navigation links for the signed-in user. */
export function useNavItems(): NavItem[] {
  const { data: user } = useCurrentUser()
  return useMemo(() => (user ? navItemsFor(user) : []), [user])
}
